
import {HiverAxios} from 'h-commons';
import { config } from '../../../config';


import { CreateApiHandler} from '../../common/helpers/thunkMiddleware';

import {FETCH_COUNTRY_LIST, FETCH_COUNTRY_STATES, FETCH_ZIP_CODE_DATA} from './types'

const zipCodeApiKey = config.ZIP_CODE_API_KEY;
const zipCodeBaseUrl = 'https://app.zipcodebase.com/api/v1';

const CountryNames = {
        "Afghanistan": "AF",
        "Aland Islands": "AX",
        "Albania": "AL",
        "Algeria": "DZ",
        "American Samoa": "AS",
        "Guinea": "GN",
        "Guinea-Bissau": "GW",
        "Guyana": "GY",
        "Haiti": "HT",
        "Heard Island and McDonald Islands": "HM",
        "Holy See (Vatican City State)": "VA",
        "Honduras": "HN",
        "Hong Kong": "HK",
        "Hungary": "HU",
        "Iceland": "IS",
        "India": "IN",
        "Indonesia": "ID",
        "Iran": "IR",
        "Iraq": "IQ",
        "Ireland": "IE",
        "Isle of Man": "IM",
        "Israel": "IL", 
}

export const getCountryStates = {
    US: [
        "Alaska", "Alabama", "Arkansas", "Arizona", "California", "Colorado", "Connecticut",
        "District of Columbia", "Delaware", "Florida", "Georgia", "Hawaii", "Iowa", "Idaho",
        "Illinois", "Indiana", "Kansas", "Kentucky", "Louisiana", "Massachusetts", "Maryland",
        "Maine", "Michigan", "Minnesota", "Missouri", "Mississippi", "Montana", "North Carolina",
        "North Dakota", "Nebraska", "New Hampshire", "New Jersey", "New Mexico", "Nevada",
        "New York", "Ohio", "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island",
        "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah", "Virginia",
        "Vermont", "Washington", "Wisconsin", "West Virginia", "Wyoming"
      ]      
};

export const fetchCountryList = CreateApiHandler((isMock=false) => {
    let url = `/api/account/country_list`;

    if(isMock){
        return new Promise((res) => {
             setTimeout(() => {
                 res({countryList: CountryNames});
             }, 3000)
        })
    }
    return new Promise((res, rej) => {
        HiverAxios({
            url,
            type: 'GET',
            callback: resp => {
                if (resp.data){
                    const countryList = {...resp.data}; 
                    res({countryList});
                }
                else{
                    rej('');
                }
            }, 
            onfail: () => {
                    rej('');
            }
        });
    })

}, FETCH_COUNTRY_LIST)



export const fetchCountryStates = CreateApiHandler((countryCode) => {
    const url = `${zipCodeBaseUrl}/country/province?apikey=${zipCodeApiKey}&country=${countryCode}`;

    return fetch(url, {
        method: 'GET'
    }).then(async (res) => {
        const data = await res.json();
        if(res.ok){
            window.top.postMessage(
                {
                    type: 'APPLICATION_PERFORMANCE_METRIC',
                    payload : {
                      message: "ZIPCODEBASE_API_SUCCESS",
                    },
                  },
                'https://mail.google.com',
            );
            return data
        }
        window.top.postMessage(
            {
                type: 'APPLICATION_PERFORMANCE_METRIC',
                payload : {
                  message: "ZIPCODEBASE_API_FAILURE",
                },
              },
            'https://mail.google.com',
        );
        throw data; 
    })

}, FETCH_COUNTRY_STATES,
{showErrorSnackbar:false} ///  Dont have to show the errorSnackbar because on the api failure we are showing the hardcoded values of US States
)


export const fetchZipCodeData = CreateApiHandler((zipCode) => {
    const url = `${zipCodeBaseUrl}/search?apikey=${zipCodeApiKey}&codes=${zipCode}`

    return fetch(url, {
        method: 'GET'
    }).then(async (res) => {
        const data = await res.json();
        if(res.ok){
            return data
        }
        throw data; 
    })

}, FETCH_ZIP_CODE_DATA)
